
function checkForMapsToInit() {
    if($('.map').length) {
        initializeMap();
    }
}